<div #container class="d-flex align-items-stretch" style="flex: 1" [ngClass]="{'mb-0': modalOptions.fullScreen || showInReport, 'card': !showInReport, 'report-view': showInReport, 'report-mode-chart': reportMode, 'position-relative': reportMode}">
    <ng-container *ngIf="!showInReport">
        <div class="card-header dropdown">
            <h4 class="card-header-title">
                <img src="assets/images/icons/7-days.png" width="20px" class="me-2">
                <span *ngIf="options.selectedDays.length !== 1">Average energy profile</span>
                <span *ngIf="options.selectedDays.length === 1">{{options.selectedDays[0]}}</span>
                <span class="mx-2 notranslate">–</span>
                <span class="notranslate">{{measurementName(options.selectedDataType, true)}}</span>
            </h4>
            <app-data-provider-date-range class="ms-2" *ngIf="modalOptions.fullScreen"></app-data-provider-date-range>
            <button *ngIf="!modalOptions.fullScreen" type="button" class="btn" role="button" (click)="openModal()">
                <i class="bi bi-arrows-angle-expand"></i>
            </button>
            <app-chart-download-button [element]="container"></app-chart-download-button>
            <button type="button" class="btn" role="button" data-bs-toggle="dropdown"
                    data-bs-auto-close="outside" aria-expanded="false">
                <i class="bi bi-three-dots-vertical"></i>
            </button>
            <app-widget-options-menu title="Display settings" [anchorBelowTrigger]="modalOptions.fullScreen">
                <div class="dropdown-item">
                    <div class="row">
                        <label class="form-check-label col-auto" [for]="getInputId('measurementType')+'-select'">Measurement</label>
                        <app-select class="col px-0" [ngModel]="options.selectedDataType" (ngModelChange)="measurementTypeChanged($event)" [id]="getInputId('measurementType')"
                                    [options]="possibleDataTypes()" [small]="true" [formatter]="dropdownFormatter"></app-select>
                    </div>
                </div>
                <div class="dropdown-item">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" value="" [id]="getInputId('official-holidays-only')"
                               [ngModel]="options.officialHolidaysOnly" (ngModelChange)="toggleOfficialHolidaysOnly($event)">
                        <label class="form-check-label" [for]="getInputId('official-holidays-only')">
                            Official holidays only
                        </label>
                    </div>
                </div>
                <app-widget-options-section title="Days of week">
                <div class="dropdown-item">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" value="" [id]="getInputId('days-of-week-all-select')"
                               [ngModel]="allDaysSelected()" (ngModelChange)="toggleAllDays($event)">
                        <label class="form-check-label" [for]="getInputId('days-of-week-all-select')">
                            Toggle all days
                        </label>
                    </div>
                </div>
                    <div *ngFor="let dayOfWeek of dashboardContext.weekdaysSorted" class="dropdown-item">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" value="" [id]="getDayOfWeekInputId(dayOfWeek)"
                                   [checked]="isDayOfWeekSelected(dayOfWeek)" (click)="toggleDayOfWeek(dayOfWeek)">
                            <label class="form-check-label" [for]="getDayOfWeekInputId(dayOfWeek)">
                                {{dayOfWeek}}
                            </label>
                        </div>
                    </div>
                </app-widget-options-section>
            </app-widget-options-menu>
            <button *ngIf="modalOptions.fullScreen" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
    </ng-container>
    <div class="chart-body pt-0 d-flex align-items-stretch mh-100" [ngClass]="{'p-0': options.showAsTable, 'card-body': !showInReport, 'position-relative': reportMode}">
        <div *ngIf="reportModeLabel" class="position-absolute top-0 start-0 z-1 text-secondary fw-semibold small">{{ reportModeLabel }}</div>
        <ng-container *ngIf="showInReport else notInReport">
            <ng-container [ngTemplateOutlet]="chart"></ng-container>
        </ng-container>
        <ng-template #notInReport>
            <ng-container [ngTemplateOutlet]="chart"></ng-container>
        </ng-template>
    </div>
</div>

<ng-template #chart>
    <app-bar-chart class="chart h-100 w-100" [stacked]="!options?.officialHolidaysOnly" [y1AxisMeasurement]="measurementUnit()"
                   style="flex: 1"
                   [y2AxisMeasurement]="y2AxisTitle" [showLegend]="!showInReport && showAsLineChart" [hideDefaultYAxis]="true"
                   [dataProvider]="chartDataProvider" [showCompleteness]="options.showCompleteness"
                   [selectedWeatherTypes]="options.selectedWeatherTypes" [weatherTypes]="appContext.weatherTypes"
                   [fullScreen]="modalOptions.fullScreen" [skipPaddingX]="modalOptions.fullScreen || (showInReport && !reportMode)"
                   [customOnClick]="showInReport ? false : navigateToDay" [customHover]="onHover" [animationDuration]="showInReport ? 0 : 1000"
                   [directiveView]="this">
    </app-bar-chart>
</ng-template>
